<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listTaxas"
        title-table="Taxas"
        module="taxasSettingsModule"
        sort-name="nome"
        add-permission="ROLE_TAXA_INSERIR"
        view-permission="ROLE_TAXA_CONSULTAR"
        edit-permission="ROLE_TAXA_ATUALIZAR"
        delete-permission="ROLE_TAXA_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormTaxa v-else @cancelar="cancelar" />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import TableComponents from "@/layouts/components/TableComponents.vue";
import { BRow, BCol } from "bootstrap-vue";
import FormTaxa from "./forms/FormTaxa.vue";

export default {
  name: "Taxa",
  components: {
    BRow,
    BCol,
    TableComponents,
    FormTaxa,
  },
  computed: {
    ...mapState("taxasSettingsModule", {
      listTaxas: (state) => state.listTaxas,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t("id"),
          field: "id",
        },
        {
          label: "Nome",
          field: "nome",
        },
        {
          label: "Percentual de Juros",
          field: "percentualJuros",
        },
        {
          label: this.$t("Action"),
          field: "action",
        },
      ],
    };
  },
  methods: {
    addNew() {
      this.showForm = true;
    },
    edit(data) {
      this.$store.dispatch("taxasSettingsModule/prepareToEdit", data);
      this.showForm = true;
    },
    cancelar() {
      this.showForm = false;
    },
  },
};
</script>
